import React from "react";
import "../../styles/ApiContentState.css";

export default function ApiContentState({ loading, error, emptyMessage }) {
  if (loading) {
    return (
      <div className="api-content-state" role="status" aria-label="Loading" aria-live="polite">
        <span className="api-content-loader" aria-hidden="true" />
      </div>
    );
  }

  return (
    <div className="api-content-state" role={error ? "alert" : "status"}>
      {error || emptyMessage}
    </div>
  );
}
